import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';
import { COMMUNITY_GUIDELINES } from '../content/legalContent';

const CommunityGuidelinesPage = () => (
  <LegalPageLayout document={COMMUNITY_GUIDELINES} activePath="/guidelines" />
);

export default CommunityGuidelinesPage;
